module.exports = __webpack_public_path__ + "img/handheld.5b0e7016.png";